import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"
import { ErrorResponse } from '@/common/types/errorResponse'

interface UseUpdateEquipmentLicensePlate {
  equipmentId?: string,
  onSuccess: () => void,
  onError: (error: ErrorResponse) => void,
}

const useUpdateEquipmentLicensePlate = ({
  equipmentId,
  onSuccess,
  onError,
}: UseUpdateEquipmentLicensePlate) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['updateEquipmentLicensePlate'],
    mutationFn: async () => {
      return privateAxios.put(`/client/equipments/${equipmentId}/update_license_plate_to_mercosul_pattern`)
    },
    onSuccess,
    onError,
  })
}

export default useUpdateEquipmentLicensePlate
